// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0077d3b3","268":"1066b178","312":"0159d874","453":"627a7c03","551":"59c132b7"}[chunkId] + ".chunk.js";
};